module.exports = __webpack_public_path__ + "img/4.943e8138.png";